export default "__VITE_ASSET__115b2165__"